import { render, staticRenderFns } from "./DistributorPreference.vue?vue&type=template&id=57ab3096&scoped=true"
import script from "./DistributorPreference.vue?vue&type=script&lang=js"
export * from "./DistributorPreference.vue?vue&type=script&lang=js"
import style0 from "./DistributorPreference.vue?vue&type=style&index=0&id=57ab3096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab3096",
  null
  
)

export default component.exports